import { useState } from "react";

const MUSICIANS = [
  {
    id: 1, name: "Marcus Webb", genre: "Jazz / Soul", location: "New York, NY",
    rate: "$180/hr", rating: 4.9, reviews: 127, verified: true, available: true,
    specialties: ["Live Performance", "Studio Recording", "Film & TV"],
    instruments: ["Piano", "Keys", "Synthesizer"],
    bio: "15 years of professional experience. Credits include Netflix originals and Broadway productions.",
    earnings: "$42,800", jobs: 89, avatar: "MW", color: "#E8A44A"
  },
  {
    id: 2, name: "Sofia Chen", genre: "Classical / Contemporary", location: "Los Angeles, CA",
    rate: "$220/hr", rating: 5.0, reviews: 84, verified: true, available: true,
    specialties: ["Studio Recording", "Film & TV", "Corporate Events"],
    instruments: ["Violin", "Viola", "Cello"],
    bio: "Julliard-trained violinist. Featured on over 200 film and TV soundtracks.",
    earnings: "$67,200", jobs: 112, avatar: "SC", color: "#7B6FE8"
  },
  {
    id: 3, name: "DeShawn Rivers", genre: "Hip-Hop / R&B", location: "Atlanta, GA",
    rate: "$140/hr", rating: 4.8, reviews: 203, verified: true, available: false,
    specialties: ["Studio Recording", "Live Performance", "Beat Production"],
    instruments: ["Drums", "Percussion", "MPC"],
    bio: "Grammy-nominated session drummer. Worked with major label artists across 3 continents.",
    earnings: "$31,500", jobs: 67, avatar: "DR", color: "#E85A4A"
  },
  {
    id: 4, name: "Priya Nair", genre: "World / Fusion", location: "Chicago, IL",
    rate: "$160/hr", rating: 4.7, reviews: 56, verified: false, available: true,
    specialties: ["Live Performance", "Cultural Events", "Studio Recording"],
    instruments: ["Sitar", "Tabla", "Flute"],
    bio: "Blending classical Indian traditions with modern composition for unique soundscapes.",
    earnings: "$18,900", jobs: 34, avatar: "PN", color: "#4AB8A4"
  },
  {
    id: 5, name: "Luca Romano", genre: "Rock / Alternative", location: "Austin, TX",
    rate: "$120/hr", rating: 4.6, reviews: 178, verified: true, available: true,
    specialties: ["Live Performance", "Studio Recording", "Touring"],
    instruments: ["Electric Guitar", "Bass", "Acoustic Guitar"],
    bio: "Touring guitarist with 10+ years on the road. Studio session credits across all major genres.",
    earnings: "$28,400", jobs: 145, avatar: "LR", color: "#4A8AE8"
  },
  {
    id: 6, name: "Amara Osei", genre: "Afrobeats / Electronic", location: "Miami, FL",
    rate: "$195/hr", rating: 4.9, reviews: 92, verified: true, available: true,
    specialties: ["Production", "Studio Recording", "Film & TV"],
    instruments: ["Producer", "DJ", "Synth"],
    bio: "Award-winning producer and sound designer. Streams across 45+ countries.",
    earnings: "$54,100", jobs: 78, avatar: "AO", color: "#E84AB8"
  }
];

const PROJECTS = [
  { id: 1, title: "Netflix Series Score", budget: "$8,000–$12,000", type: "Film & TV", deadline: "Mar 28", urgent: true, client: "Wavelength Studios", needs: "String quartet for 6-episode limited series" },
  { id: 2, title: "Corporate Event — Live Jazz", budget: "$2,500", type: "Live Performance", deadline: "Apr 5", urgent: false, client: "Fortune 500 Co.", needs: "Jazz trio for annual gala, 3 hours" },
  { id: 3, title: "Album Recording Sessions", budget: "$4,000–$6,000", type: "Studio Recording", deadline: "Apr 15", urgent: false, client: "Indie Artist — J. Morel", needs: "Experienced session musicians across genres" },
  { id: 4, title: "Ad Campaign Soundtrack", budget: "$3,200", type: "Commercial", deadline: "Mar 22", urgent: true, client: "Brand Agency BBDO", needs: "30-sec + 60-sec music beds, upbeat electronic" },
];

const CONTRACT_STAGES = ["Terms", "Review", "Sign", "Active"];

export default function PlugdIn() {
  const [view, setView] = useState("home");
  const [selectedMusician, setSelectedMusician] = useState(null);
  const [contractStep, setContractStep] = useState(0);
  const [contractSigned, setContractSigned] = useState(false);
  const [filter, setFilter] = useState("All");
  const [adminView, setAdminView] = useState("locked");
  const [lockedAccounts, setLockedAccounts] = useState([
    { id: 1, name: "Theo Marchetti", email: "theo@email.com", attempts: 3, locked: true, time: "2 mins ago" },
    { id: 2, name: "Yasmin Ortiz", email: "yasmin@email.com", attempts: 3, locked: true, time: "14 mins ago" },
    { id: 3, name: "Ben Kwame", email: "ben.k@email.com", attempts: 3, locked: true, time: "1 hr ago" },
  ]);
  const [unlocking, setUnlocking] = useState(null);
  const [unlocked, setUnlocked] = useState([]);
  const [notification, setNotification] = useState(null);
  const [contractData, setContractData] = useState({
    projectType: "Studio Recording", deliverables: "", timeline: "2 weeks", rate: "$180/hr", revisions: "2"
  });

  const showNotif = (msg, type = "success") => {
    setNotification({ msg, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const handleUnlock = (id) => {
    setUnlocking(id);
    setTimeout(() => {
      setLockedAccounts(prev => prev.map(a => a.id === id ? { ...a, locked: false } : a));
      setUnlocked(prev => [...prev, id]);
      setUnlocking(null);
      showNotif("Account unlocked & email sent to user");
    }, 1500);
  };

  const genres = ["All", "Jazz", "Classical", "Hip-Hop", "Rock", "World", "Electronic"];
  const filtered = filter === "All" ? MUSICIANS : MUSICIANS.filter(m => m.genre.toLowerCase().includes(filter.toLowerCase()));

  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500&display=swap');
    * { margin: 0; padding: 0; box-sizing: border-box; }
    :root {
      --bg: #0A0A0F;
      --surface: #12121A;
      --surface2: #1A1A26;
      --border: rgba(255,255,255,0.07);
      --accent: #C8FF57;
      --accent2: #57C8FF;
      --accent3: #FF6B57;
      --text: #F0F0FF;
      --muted: rgba(240,240,255,0.45);
      --radius: 14px;
    }
    body { background: var(--bg); color: var(--text); font-family: 'DM Sans', sans-serif; min-height: 100vh; }
    .syne { font-family: 'Syne', sans-serif; }
    .app { min-height: 100vh; }

    /* NAV */
    .nav { display: flex; align-items: center; justify-content: space-between; padding: 0 40px; height: 64px; border-bottom: 1px solid var(--border); position: sticky; top: 0; z-index: 100; background: rgba(10,10,15,0.92); backdrop-filter: blur(20px); }
    .logo { font-family: 'Syne', sans-serif; font-weight: 800; font-size: 22px; letter-spacing: -0.5px; }
    .logo span { color: var(--accent); }
    .nav-links { display: flex; gap: 8px; }
    .nav-btn { background: none; border: none; color: var(--muted); font-family: 'DM Sans', sans-serif; font-size: 14px; padding: 8px 16px; border-radius: 8px; cursor: pointer; transition: all 0.2s; }
    .nav-btn:hover, .nav-btn.active { color: var(--text); background: var(--surface2); }
    .nav-btn.accent { background: var(--accent); color: #0A0A0F; font-weight: 600; }
    .nav-btn.accent:hover { opacity: 0.9; }

    /* HERO */
    .hero { padding: 100px 40px 80px; text-align: center; position: relative; overflow: hidden; }
    .hero::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse 60% 50% at 50% 0%, rgba(200,255,87,0.08) 0%, transparent 70%); pointer-events: none; }
    .hero-badge { display: inline-flex; align-items: center; gap: 8px; background: rgba(200,255,87,0.1); border: 1px solid rgba(200,255,87,0.2); color: var(--accent); font-size: 12px; font-weight: 600; padding: 6px 14px; border-radius: 100px; letter-spacing: 0.5px; text-transform: uppercase; margin-bottom: 32px; }
    .hero-badge::before { content: ''; width: 6px; height: 6px; border-radius: 50%; background: var(--accent); animation: pulse 2s infinite; }
    @keyframes pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.5;transform:scale(1.4)} }
    .hero h1 { font-family: 'Syne', sans-serif; font-size: clamp(48px, 7vw, 88px); font-weight: 800; line-height: 0.95; letter-spacing: -2px; margin-bottom: 28px; }
    .hero h1 em { font-style: normal; color: var(--accent); }
    .hero p { color: var(--muted); font-size: 18px; max-width: 560px; margin: 0 auto 48px; line-height: 1.6; font-weight: 300; }
    .hero-ctas { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }
    .btn-primary { background: var(--accent); color: #0A0A0F; font-family: 'Syne', sans-serif; font-weight: 700; font-size: 15px; border: none; padding: 14px 28px; border-radius: 10px; cursor: pointer; transition: all 0.2s; }
    .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 12px 40px rgba(200,255,87,0.25); }
    .btn-secondary { background: var(--surface2); color: var(--text); font-family: 'DM Sans', sans-serif; font-size: 15px; border: 1px solid var(--border); padding: 14px 28px; border-radius: 10px; cursor: pointer; transition: all 0.2s; }
    .btn-secondary:hover { border-color: rgba(255,255,255,0.15); transform: translateY(-2px); }

    /* STATS */
    .stats { display: grid; grid-template-columns: repeat(4,1fr); gap: 1px; background: var(--border); border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); }
    .stat { background: var(--bg); padding: 36px 40px; }
    .stat-num { font-family: 'Syne', sans-serif; font-size: 40px; font-weight: 800; letter-spacing: -1px; color: var(--accent); }
    .stat-label { color: var(--muted); font-size: 13px; margin-top: 4px; }

    /* SECTION */
    .section { padding: 80px 40px; }
    .section-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 40px; }
    .section-title { font-family: 'Syne', sans-serif; font-size: 28px; font-weight: 700; }
    .section-sub { color: var(--muted); font-size: 14px; margin-top: 4px; }

    /* FILTERS */
    .filters { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 32px; }
    .filter-btn { background: var(--surface); border: 1px solid var(--border); color: var(--muted); font-size: 13px; padding: 7px 16px; border-radius: 100px; cursor: pointer; transition: all 0.2s; }
    .filter-btn:hover, .filter-btn.active { background: var(--accent); color: #0A0A0F; border-color: var(--accent); font-weight: 600; }

    /* MUSICIAN CARDS */
    .grid-3 { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; }
    .musician-card { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); padding: 24px; cursor: pointer; transition: all 0.25s; position: relative; overflow: hidden; }
    .musician-card::before { content: ''; position: absolute; inset: 0; opacity: 0; transition: opacity 0.25s; background: radial-gradient(ellipse 80% 60% at 50% 0%, rgba(200,255,87,0.05) 0%, transparent 70%); }
    .musician-card:hover { border-color: rgba(255,255,255,0.15); transform: translateY(-3px); box-shadow: 0 20px 60px rgba(0,0,0,0.4); }
    .musician-card:hover::before { opacity: 1; }
    .card-top { display: flex; align-items: flex-start; gap: 16px; margin-bottom: 16px; }
    .avatar { width: 52px; height: 52px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-family: 'Syne', sans-serif; font-weight: 700; font-size: 16px; color: #0A0A0F; flex-shrink: 0; }
    .card-info { flex: 1; }
    .card-name { font-family: 'Syne', sans-serif; font-weight: 700; font-size: 17px; }
    .card-genre { color: var(--muted); font-size: 13px; margin-top: 2px; }
    .card-location { color: var(--muted); font-size: 12px; margin-top: 1px; }
    .available-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-top: 6px; }
    .chips { display: flex; flex-wrap: wrap; gap: 6px; margin: 12px 0; }
    .chip { font-size: 11px; padding: 4px 10px; border-radius: 6px; background: var(--surface2); border: 1px solid var(--border); color: var(--muted); }
    .card-footer { display: flex; align-items: center; justify-content: space-between; padding-top: 16px; border-top: 1px solid var(--border); margin-top: 8px; }
    .rate { font-family: 'Syne', sans-serif; font-weight: 700; font-size: 16px; color: var(--accent); }
    .rating { display: flex; align-items: center; gap: 5px; font-size: 13px; color: var(--muted); }
    .star { color: #FFB830; }
    .verified-badge { display: flex; align-items: center; gap: 4px; font-size: 11px; color: var(--accent2); background: rgba(87,200,255,0.1); padding: 3px 8px; border-radius: 6px; border: 1px solid rgba(87,200,255,0.2); }

    /* PROJECTS */
    .project-list { display: flex; flex-direction: column; gap: 12px; }
    .project-card { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); padding: 20px 24px; display: flex; align-items: center; gap: 20px; transition: all 0.2s; cursor: pointer; }
    .project-card:hover { border-color: rgba(255,255,255,0.12); }
    .project-type-badge { font-size: 11px; font-weight: 600; padding: 4px 10px; border-radius: 6px; white-space: nowrap; }
    .project-info { flex: 1; }
    .project-title { font-family: 'Syne', sans-serif; font-weight: 700; font-size: 16px; }
    .project-needs { color: var(--muted); font-size: 13px; margin-top: 3px; }
    .project-client { color: var(--muted); font-size: 12px; margin-top: 2px; }
    .project-meta { display: flex; flex-direction: column; align-items: flex-end; gap: 6px; }
    .project-budget { font-family: 'Syne', sans-serif; font-weight: 700; font-size: 16px; color: var(--accent); }
    .urgent-tag { font-size: 10px; font-weight: 700; background: rgba(255,107,87,0.15); color: var(--accent3); padding: 3px 8px; border-radius: 4px; letter-spacing: 0.5px; text-transform: uppercase; }
    .deadline { color: var(--muted); font-size: 12px; }

    /* MODAL */
    .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.75); backdrop-filter: blur(8px); z-index: 200; display: flex; align-items: center; justify-content: center; padding: 20px; animation: fadeIn 0.2s; }
    @keyframes fadeIn { from{opacity:0} to{opacity:1} }
    .modal { background: var(--surface); border: 1px solid rgba(255,255,255,0.1); border-radius: 20px; width: 100%; max-width: 640px; max-height: 85vh; overflow-y: auto; animation: slideUp 0.3s cubic-bezier(0.34,1.56,0.64,1); }
    @keyframes slideUp { from{opacity:0;transform:translateY(30px)} to{opacity:1;transform:translateY(0)} }
    .modal-header { padding: 28px 28px 0; display: flex; align-items: flex-start; justify-content: space-between; }
    .modal-body { padding: 24px 28px 28px; }
    .close-btn { background: var(--surface2); border: none; color: var(--muted); width: 32px; height: 32px; border-radius: 8px; cursor: pointer; font-size: 18px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .close-btn:hover { color: var(--text); }

    /* CONTRACT */
    .contract-steps { display: flex; gap: 0; margin-bottom: 32px; }
    .step { flex: 1; display: flex; flex-direction: column; align-items: center; position: relative; }
    .step::after { content: ''; position: absolute; top: 14px; left: 50%; width: 100%; height: 2px; background: var(--border); z-index: 0; }
    .step:last-child::after { display: none; }
    .step-dot { width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; z-index: 1; margin-bottom: 8px; transition: all 0.3s; }
    .step-dot.done { background: var(--accent); color: #0A0A0F; }
    .step-dot.active { background: var(--surface2); border: 2px solid var(--accent); color: var(--accent); }
    .step-dot.pending { background: var(--surface2); border: 2px solid var(--border); color: var(--muted); }
    .step-label { font-size: 11px; color: var(--muted); text-align: center; }
    .form-row { margin-bottom: 18px; }
    .form-label { font-size: 12px; font-weight: 600; color: var(--muted); text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 8px; display: block; }
    .form-input, .form-select, .form-textarea { width: 100%; background: var(--surface2); border: 1px solid var(--border); color: var(--text); font-family: 'DM Sans', sans-serif; font-size: 14px; padding: 10px 14px; border-radius: 8px; outline: none; transition: border-color 0.2s; }
    .form-input:focus, .form-select:focus, .form-textarea:focus { border-color: rgba(200,255,87,0.4); }
    .form-textarea { resize: vertical; min-height: 80px; }
    .form-select option { background: var(--surface2); }
    .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
    .contract-preview { background: var(--bg); border: 1px solid var(--border); border-radius: 10px; padding: 20px; font-size: 13px; line-height: 1.7; color: var(--muted); margin: 16px 0; }
    .contract-preview strong { color: var(--text); }
    .sig-box { background: var(--surface2); border: 2px dashed var(--border); border-radius: 10px; padding: 24px; text-align: center; cursor: pointer; transition: all 0.2s; margin: 12px 0; }
    .sig-box:hover { border-color: var(--accent); }
    .sig-box.signed { border-color: var(--accent); border-style: solid; background: rgba(200,255,87,0.05); }

    /* ADMIN */
    .admin-tabs { display: flex; gap: 8px; margin-bottom: 28px; }
    .admin-tab { background: var(--surface); border: 1px solid var(--border); color: var(--muted); font-size: 13px; padding: 8px 18px; border-radius: 8px; cursor: pointer; transition: all 0.2s; }
    .admin-tab.active { background: var(--surface2); color: var(--text); border-color: rgba(255,255,255,0.15); }
    .account-row { background: var(--surface); border: 1px solid var(--border); border-radius: 12px; padding: 16px 20px; display: flex; align-items: center; gap: 16px; margin-bottom: 12px; transition: all 0.2s; }
    .lock-icon { font-size: 20px; }
    .account-info { flex: 1; }
    .account-name { font-family: 'Syne', sans-serif; font-weight: 600; font-size: 15px; }
    .account-email { color: var(--muted); font-size: 12px; margin-top: 2px; }
    .account-time { color: var(--muted); font-size: 12px; white-space: nowrap; }
    .unlock-btn { background: rgba(200,255,87,0.1); border: 1px solid rgba(200,255,87,0.3); color: var(--accent); font-family: 'Syne', sans-serif; font-weight: 700; font-size: 13px; padding: 8px 18px; border-radius: 8px; cursor: pointer; transition: all 0.2s; white-space: nowrap; }
    .unlock-btn:hover { background: rgba(200,255,87,0.2); }
    .unlock-btn:disabled { opacity: 0.5; cursor: not-allowed; }
    .unlocked-tag { font-size: 12px; color: var(--accent); background: rgba(200,255,87,0.08); padding: 6px 12px; border-radius: 8px; border: 1px solid rgba(200,255,87,0.15); }
    .attempts-badge { font-size: 11px; background: rgba(255,107,87,0.15); color: var(--accent3); padding: 3px 8px; border-radius: 6px; border: 1px solid rgba(255,107,87,0.2); font-weight: 600; }

    /* PROFILE VIEW */
    .profile-hero { background: linear-gradient(180deg, var(--surface2) 0%, var(--surface) 100%); border-radius: 16px; padding: 32px; margin-bottom: 20px; position: relative; overflow: hidden; }
    .profile-hero::before { content: ''; position: absolute; top: -40px; right: -40px; width: 200px; height: 200px; border-radius: 50%; opacity: 0.08; }
    .profile-top { display: flex; align-items: flex-start; gap: 20px; }
    .avatar-lg { width: 72px; height: 72px; border-radius: 16px; display: flex; align-items: center; justify-content: center; font-family: 'Syne', sans-serif; font-weight: 800; font-size: 22px; color: #0A0A0F; flex-shrink: 0; }
    .profile-stats { display: grid; grid-template-columns: repeat(3,1fr); gap: 12px; margin-top: 24px; }
    .pstat { background: rgba(0,0,0,0.2); border-radius: 10px; padding: 14px; text-align: center; }
    .pstat-val { font-family: 'Syne', sans-serif; font-weight: 800; font-size: 20px; }
    .pstat-key { color: var(--muted); font-size: 11px; margin-top: 2px; }

    /* NOTIF */
    .notif { position: fixed; bottom: 32px; right: 32px; background: var(--surface2); border: 1px solid var(--border); border-radius: 12px; padding: 14px 20px; font-size: 14px; z-index: 999; animation: slideUp 0.3s; display: flex; align-items: center; gap: 10px; box-shadow: 0 20px 60px rgba(0,0,0,0.4); }
    .notif::before { content: '✓'; width: 22px; height: 22px; border-radius: 50%; background: var(--accent); color: #0A0A0F; font-weight: 800; font-size: 12px; display: flex; align-items: center; justify-content: center; }

    /* MISC */
    .divider { height: 1px; background: var(--border); margin: 24px 0; }
    .text-accent { color: var(--accent); }
    .text-muted { color: var(--muted); }
    .font-bold { font-weight: 700; }
    .mt-8 { margin-top: 8px; }
    .mb-16 { margin-bottom: 16px; }
    .flex { display: flex; }
    .items-center { align-items: center; }
    .gap-8 { gap: 8px; }
    .justify-between { justify-content: space-between; }

    @media(max-width: 768px) {
      .grid-3 { grid-template-columns: 1fr; }
      .stats { grid-template-columns: repeat(2,1fr); }
      .hero { padding: 60px 20px; }
      .section { padding: 40px 20px; }
      .nav { padding: 0 20px; }
      .form-grid { grid-template-columns: 1fr; }
    }
  `;

  const getTypeColor = (type) => {
    const map = { "Film & TV": { bg: "rgba(123,111,232,0.15)", color: "#9B8FF8", border: "rgba(123,111,232,0.3)" }, "Live Performance": { bg: "rgba(200,255,87,0.1)", color: "#C8FF57", border: "rgba(200,255,87,0.25)" }, "Studio Recording": { bg: "rgba(87,200,255,0.1)", color: "#57C8FF", border: "rgba(87,200,255,0.25)" }, "Commercial": { bg: "rgba(255,107,87,0.1)", color: "#FF6B57", border: "rgba(255,107,87,0.25)" } };
    return map[type] || { bg: "rgba(255,255,255,0.05)", color: "#aaa", border: "rgba(255,255,255,0.1)" };
  };

  return (
    <div className="app">
      <style>{styles}</style>

      {/* NOTIFICATION */}
      {notification && <div className="notif">{notification.msg}</div>}

      {/* NAV */}
      <nav className="nav">
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <img src="https://static.wixstatic.com/media/89a903_9e391cc0bfcb4b2fadcd40294b67db4e~mv2.png/v1/crop/x_0,y_203,w_1089,h_909/fill/w_91,h_76,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/mgm%20logo.png" alt="MyGuyMars" style={{ height: "40px", objectFit: "contain" }} />
          <div className="logo syne">Better<span>Together</span></div>
        </div>
        <div className="nav-links">
          {[["home", "Discover"], ["projects", "Projects"], ["profile", "My Profile"], ["admin", "Admin"]].map(([v, l]) => (
            <button key={v} className={`nav-btn ${view === v ? "active" : ""}`} onClick={() => setView(v)}>{l}</button>
          ))}
          <button className="nav-btn accent">Post a Job</button>
        </div>
      </nav>

      {/* HOME */}
      {view === "home" && (
        <>
          <section className="hero">
            <div className="hero-badge">Now in Beta · 2,400+ Musicians</div>
            <h1>We're <em>Better</em><br /><em>Together</em></h1>
            <p>The professional marketplace connecting musicians with studios, film productions, brands, and live events. Inspired by AfterChurchLA. Showcase your craft. Get booked.</p>
            <div className="hero-ctas">
              <button className="btn-primary" onClick={() => setView("projects")}>Browse Projects</button>
              <button className="btn-secondary" onClick={() => setView("profile")}>Create Your Profile →</button>
            </div>
          </section>

          <div className="stats">
            {[["2,400+", "Verified Musicians"], ["$4.2M", "Paid Out"], ["18K+", "Projects Completed"], ["4.9★", "Avg. Rating"]].map(([n, l]) => (
              <div key={l} className="stat">
                <div className="stat-num syne">{n}</div>
                <div className="stat-label">{l}</div>
              </div>
            ))}
          </div>

          <section className="section">
            <div className="section-header">
              <div>
                <div className="section-title syne">Featured Musicians</div>
                <div className="section-sub">Handpicked talent ready to work</div>
              </div>
            </div>
            <div className="filters">
              {genres.map(g => (
                <button key={g} className={`filter-btn ${filter === g ? "active" : ""}`} onClick={() => setFilter(g)}>{g}</button>
              ))}
            </div>
            <div className="grid-3">
              {filtered.map(m => (
                <div key={m.id} className="musician-card" onClick={() => { setSelectedMusician(m); setContractStep(0); setContractSigned(false); }}>
                  <div className="card-top">
                    <div className="avatar" style={{ background: m.color }}>{m.avatar}</div>
                    <div className="card-info">
                      <div className="card-name">{m.name}</div>
                      <div className="card-genre">{m.genre}</div>
                      <div className="card-location">📍 {m.location}</div>
                    </div>
                    <div className="available-dot" style={{ background: m.available ? "#C8FF57" : "#555" }} title={m.available ? "Available" : "Busy"} />
                  </div>
                  {m.verified && <div className="verified-badge" style={{ display: "inline-flex", marginBottom: 8 }}>✓ Verified Pro</div>}
                  <div className="chips">
                    {m.instruments.map(i => <span key={i} className="chip">{i}</span>)}
                  </div>
                  <div className="chips">
                    {m.specialties.slice(0, 2).map(s => <span key={s} className="chip" style={{ color: "#C8FF57", borderColor: "rgba(200,255,87,0.2)" }}>{s}</span>)}
                  </div>
                  <div className="card-footer">
                    <div className="rate">{m.rate}</div>
                    <div className="rating"><span className="star">★</span> {m.rating} <span style={{ fontSize: 11 }}>({m.reviews})</span></div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </>
      )}

      {/* PROJECTS */}
      {view === "projects" && (
        <section className="section">
          <div className="section-header">
            <div>
              <div className="section-title syne">Open Projects</div>
              <div className="section-sub">Live gigs, studio sessions, film & TV — apply directly</div>
            </div>
            <button className="btn-primary" onClick={() => showNotif("Project posted successfully!")}>+ Post Project</button>
          </div>
          <div className="project-list">
            {PROJECTS.map(p => {
              const tc = getTypeColor(p.type);
              return (
                <div key={p.id} className="project-card" onClick={() => { setSelectedMusician({ _project: true, ...p }); }}>
                  <span className="project-type-badge" style={{ background: tc.bg, color: tc.color, border: `1px solid ${tc.border}` }}>{p.type}</span>
                  <div className="project-info">
                    <div className="project-title">{p.title}</div>
                    <div className="project-needs">{p.needs}</div>
                    <div className="project-client">Client: {p.client}</div>
                  </div>
                  <div className="project-meta">
                    <div className="project-budget">{p.budget}</div>
                    {p.urgent && <span className="urgent-tag">Urgent</span>}
                    <span className="deadline">Due {p.deadline}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      )}

      {/* PROFILE */}
      {view === "profile" && (
        <section className="section">
          <div className="section-title syne" style={{ marginBottom: 24 }}>Musician Profile</div>
          <div className="profile-hero">
            <div className="profile-top">
              <div className="avatar-lg" style={{ background: "#E8A44A" }}>MW</div>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                  <div className="section-title syne" style={{ fontSize: 22 }}>Marcus Webb</div>
                  <div className="verified-badge">✓ Verified Pro</div>
                  <div style={{ fontSize: 12, background: "rgba(200,255,87,0.1)", color: "var(--accent)", padding: "3px 10px", borderRadius: 6, border: "1px solid rgba(200,255,87,0.2)" }}>● Available</div>
                </div>
                <div style={{ color: "var(--muted)", fontSize: 14, marginTop: 4 }}>Jazz / Soul · Piano, Keys, Synthesizer · New York, NY</div>
                <div style={{ color: "var(--muted)", fontSize: 14, marginTop: 8, maxWidth: 500 }}>15 years of professional experience. Credits include Netflix originals and Broadway productions.</div>
                <div style={{ display: "flex", gap: 10, marginTop: 16, flexWrap: "wrap" }}>
                  {["Live Performance", "Studio Recording", "Film & TV"].map(s => {
                    const tc = getTypeColor(s);
                    return <span key={s} className="project-type-badge" style={{ background: tc.bg, color: tc.color, border: `1px solid ${tc.border}`, fontSize: 11, padding: "4px 10px", borderRadius: 6 }}>{s}</span>;
                  })}
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div className="rate" style={{ fontSize: 22 }}>$180/hr</div>
                <div className="rating" style={{ justifyContent: "flex-end", marginTop: 4 }}><span className="star">★</span> 4.9 (127 reviews)</div>
              </div>
            </div>
            <div className="profile-stats">
              {[["$42,800", "Total Earned"], ["89", "Jobs Completed"], ["100%", "Job Success"]].map(([v, k]) => (
                <div key={k} className="pstat">
                  <div className="pstat-val text-accent syne">{v}</div>
                  <div className="pstat-key">{k}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid-3" style={{ gap: 16, marginBottom: 24 }}>
            {["Showcase Video 1", "Showcase Video 2", "Studio Session"].map((v, i) => (
              <div key={i} style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 12, aspectRatio: "16/9", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, cursor: "pointer", transition: "all 0.2s" }}
                onClick={() => showNotif("Video player opening...")}>
                <div style={{ fontSize: 32 }}>▶️</div>
                <div style={{ fontSize: 13, color: "var(--muted)" }}>{v}</div>
              </div>
            ))}
          </div>

          <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 14, padding: 24 }}>
            <div className="syne" style={{ fontWeight: 700, marginBottom: 16 }}>Upload New Work</div>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              {["🎬 Upload Video", "🎵 Upload Audio", "📄 Add Credits"].map(a => (
                <button key={a} className="btn-secondary" style={{ fontSize: 13 }} onClick={() => showNotif("File upload opened")}>{a}</button>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ADMIN */}
      {view === "admin" && (
        <section className="section">
          <div className="section-title syne" style={{ marginBottom: 8 }}>Admin Panel</div>
          <div style={{ color: "var(--muted)", fontSize: 14, marginBottom: 28 }}>Access management and platform oversight</div>
          <div className="admin-tabs">
            {[["locked", "🔒 Locked Accounts"], ["activity", "📊 Activity Log"], ["flagged", "⚠️ Flagged Users"]].map(([v, l]) => (
              <button key={v} className={`admin-tab ${adminView === v ? "active" : ""}`} onClick={() => setAdminView(v)}>{l}</button>
            ))}
          </div>

          {adminView === "locked" && (
            <>
              <div style={{ background: "rgba(255,107,87,0.06)", border: "1px solid rgba(255,107,87,0.15)", borderRadius: 12, padding: "14px 20px", marginBottom: 24, display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ fontSize: 20 }}>🔐</span>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>Accounts locked after 3 failed login attempts</div>
                  <div style={{ color: "var(--muted)", fontSize: 12, marginTop: 2 }}>Users are notified via email. Unlock manually or send a password reset link.</div>
                </div>
                <div style={{ marginLeft: "auto", fontFamily: "Syne", fontWeight: 800, fontSize: 28, color: "var(--accent3)" }}>{lockedAccounts.filter(a => a.locked && !unlocked.includes(a.id)).length}</div>
              </div>
              {lockedAccounts.map(account => (
                <div key={account.id} className="account-row" style={{ opacity: unlocked.includes(account.id) ? 0.6 : 1 }}>
                  <span className="lock-icon">{unlocked.includes(account.id) ? "🔓" : "🔒"}</span>
                  <div className="account-info">
                    <div className="account-name">{account.name}</div>
                    <div className="account-email">{account.email}</div>
                    <span className="attempts-badge" style={{ display: "inline-block", marginTop: 6 }}>3/3 attempts</span>
                  </div>
                  <div className="account-time">{account.time}</div>
                  {unlocked.includes(account.id) ? (
                    <div className="unlocked-tag">✓ Unlocked</div>
                  ) : (
                    <button className="unlock-btn" disabled={unlocking === account.id} onClick={() => handleUnlock(account.id)}>
                      {unlocking === account.id ? "Unlocking..." : "Unlock Account"}
                    </button>
                  )}
                </div>
              ))}
            </>
          )}

          {adminView === "activity" && (
            <div>
              {[
                ["✅", "Sofia Chen completed a contract", "Film Score · $3,200", "2m ago"],
                ["📝", "New project posted by Wavelength Studios", "Netflix Series Score", "18m ago"],
                ["🎵", "DeShawn Rivers updated their portfolio", "Added 3 new videos", "1h ago"],
                ["⚠️", "Login attempt flagged", "IP: 192.168.1.44", "2h ago"],
                ["💰", "Payment processed for Luca Romano", "$1,440 · Studio session", "3h ago"],
              ].map(([icon, title, sub, time], i) => (
                <div key={i} className="account-row">
                  <span style={{ fontSize: 22 }}>{icon}</span>
                  <div className="account-info">
                    <div style={{ fontWeight: 500, fontSize: 14 }}>{title}</div>
                    <div className="account-email">{sub}</div>
                  </div>
                  <div className="account-time">{time}</div>
                </div>
              ))}
            </div>
          )}

          {adminView === "flagged" && (
            <div style={{ textAlign: "center", padding: "60px 0", color: "var(--muted)" }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
              <div style={{ fontFamily: "Syne", fontWeight: 700, fontSize: 18, color: "var(--text)" }}>No flagged accounts</div>
              <div style={{ fontSize: 14, marginTop: 8 }}>Platform activity looks clean</div>
            </div>
          )}
        </section>
      )}

      {/* MUSICIAN DETAIL + CONTRACT MODAL */}
      {selectedMusician && !selectedMusician._project && (
        <div className="modal-overlay" onClick={(e) => e.target.className === "modal-overlay" && setSelectedMusician(null)}>
          <div className="modal">
            <div className="modal-header">
              <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                <div className="avatar-lg" style={{ background: selectedMusician.color, width: 56, height: 56, fontSize: 18 }}>{selectedMusician.avatar}</div>
                <div>
                  <div className="syne" style={{ fontWeight: 700, fontSize: 20 }}>{selectedMusician.name}</div>
                  <div style={{ color: "var(--muted)", fontSize: 13 }}>{selectedMusician.genre} · {selectedMusician.location}</div>
                </div>
              </div>
              <button className="close-btn" onClick={() => setSelectedMusician(null)}>✕</button>
            </div>
            <div className="modal-body">
              <p style={{ color: "var(--muted)", fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>{selectedMusician.bio}</p>
              <div style={{ display: "flex", gap: 24, marginBottom: 20 }}>
                <div><div style={{ color: "var(--accent)", fontFamily: "Syne", fontWeight: 800, fontSize: 22 }}>{selectedMusician.rate}</div><div style={{ color: "var(--muted)", fontSize: 12 }}>Hourly Rate</div></div>
                <div><div style={{ color: "var(--accent)", fontFamily: "Syne", fontWeight: 800, fontSize: 22 }}>★ {selectedMusician.rating}</div><div style={{ color: "var(--muted)", fontSize: 12 }}>{selectedMusician.reviews} Reviews</div></div>
                <div><div style={{ color: "var(--accent)", fontFamily: "Syne", fontWeight: 800, fontSize: 22 }}>{selectedMusician.jobs}</div><div style={{ color: "var(--muted)", fontSize: 12 }}>Jobs Done</div></div>
              </div>

              <div className="divider" />
              <div className="syne" style={{ fontWeight: 700, marginBottom: 20 }}>Create a Contract</div>

              <div className="contract-steps">
                {CONTRACT_STAGES.map((s, i) => (
                  <div key={s} className="step">
                    <div className={`step-dot ${i < contractStep ? "done" : i === contractStep ? "active" : "pending"}`}>
                      {i < contractStep ? "✓" : i + 1}
                    </div>
                    <div className="step-label">{s}</div>
                  </div>
                ))}
              </div>

              {contractStep === 0 && (
                <div>
                  <div className="form-grid">
                    <div className="form-row">
                      <label className="form-label">Project Type</label>
                      <select className="form-select" value={contractData.projectType} onChange={e => setContractData({ ...contractData, projectType: e.target.value })}>
                        <option>Studio Recording</option><option>Live Performance</option><option>Film & TV</option><option>Corporate Event</option>
                      </select>
                    </div>
                    <div className="form-row">
                      <label className="form-label">Timeline</label>
                      <select className="form-select" value={contractData.timeline} onChange={e => setContractData({ ...contractData, timeline: e.target.value })}>
                        <option>1 week</option><option>2 weeks</option><option>1 month</option><option>Ongoing</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-row">
                    <label className="form-label">Deliverables</label>
                    <textarea className="form-textarea" placeholder="Describe what you need..." value={contractData.deliverables} onChange={e => setContractData({ ...contractData, deliverables: e.target.value })} />
                  </div>
                  <div className="form-grid">
                    <div className="form-row">
                      <label className="form-label">Agreed Rate</label>
                      <input className="form-input" value={contractData.rate} onChange={e => setContractData({ ...contractData, rate: e.target.value })} />
                    </div>
                    <div className="form-row">
                      <label className="form-label">Revision Rounds</label>
                      <select className="form-select" value={contractData.revisions} onChange={e => setContractData({ ...contractData, revisions: e.target.value })}>
                        <option>1</option><option>2</option><option>3</option><option>Unlimited</option>
                      </select>
                    </div>
                  </div>
                  <button className="btn-primary" style={{ width: "100%" }} onClick={() => setContractStep(1)}>Continue to Review →</button>
                </div>
              )}

              {contractStep === 1 && (
                <div>
                  <div className="contract-preview">
                    <strong>SERVICE AGREEMENT — PlugdIn Platform</strong><br /><br />
                    <strong>Client:</strong> [Your Company / Name]<br />
                    <strong>Musician:</strong> {selectedMusician.name}<br />
                    <strong>Project Type:</strong> {contractData.projectType}<br />
                    <strong>Timeline:</strong> {contractData.timeline}<br />
                    <strong>Rate:</strong> {contractData.rate}<br />
                    <strong>Revisions:</strong> {contractData.revisions} round(s)<br />
                    <strong>Deliverables:</strong> {contractData.deliverables || "As discussed"}<br /><br />
                    Payment is held in escrow by PlugdIn until work is approved. Both parties agree to the PlugdIn dispute resolution policy. Work begins only after both signatures are received.
                  </div>
                  <div style={{ display: "flex", gap: 10 }}>
                    <button className="btn-secondary" style={{ flex: 1 }} onClick={() => setContractStep(0)}>← Edit</button>
                    <button className="btn-primary" style={{ flex: 2 }} onClick={() => setContractStep(2)}>Looks Good →</button>
                  </div>
                </div>
              )}

              {contractStep === 2 && (
                <div>
                  <div style={{ fontSize: 14, color: "var(--muted)", marginBottom: 16 }}>Both parties must sign below to activate the contract and release escrow instructions.</div>
                  <div className="sig-box signed"><div style={{ color: "var(--accent)", fontFamily: "Syne", fontWeight: 700 }}>✓ Client Signed</div></div>
                  <div className={`sig-box ${contractSigned ? "signed" : ""}`} onClick={() => setContractSigned(true)}>
                    {contractSigned
                      ? <div style={{ color: "var(--accent)", fontFamily: "Syne", fontWeight: 700 }}>✓ {selectedMusician.name} Signed</div>
                      : <div style={{ color: "var(--muted)", fontSize: 14 }}>Click to simulate musician's e-signature</div>}
                  </div>
                  <button className="btn-primary" style={{ width: "100%", marginTop: 8, opacity: contractSigned ? 1 : 0.4 }}
                    onClick={() => { if (contractSigned) { setContractStep(3); showNotif("Contract activated! Work can now begin."); } }}>
                    Activate Contract
                  </button>
                </div>
              )}

              {contractStep === 3 && (
                <div style={{ textAlign: "center", padding: "20px 0" }}>
                  <div style={{ fontSize: 52, marginBottom: 12 }}>🎉</div>
                  <div className="syne" style={{ fontWeight: 800, fontSize: 22, color: "var(--accent)" }}>Contract Active!</div>
                  <div style={{ color: "var(--muted)", fontSize: 14, marginTop: 8, lineHeight: 1.6 }}>Your contract with <strong style={{ color: "var(--text)" }}>{selectedMusician.name}</strong> is live. Escrow funds are held securely until you approve the work.</div>
                  <div style={{ display: "flex", gap: 10, marginTop: 24 }}>
                    <button className="btn-secondary" style={{ flex: 1 }} onClick={() => setSelectedMusician(null)}>Close</button>
                    <button className="btn-primary" style={{ flex: 1 }} onClick={() => { showNotif("Opening messages..."); setSelectedMusician(null); }}>Message Musician</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* PROJECT APPLY MODAL */}
      {selectedMusician && selectedMusician._project && (
        <div className="modal-overlay" onClick={(e) => e.target.className === "modal-overlay" && setSelectedMusician(null)}>
          <div className="modal">
            <div className="modal-header">
              <div>
                <div className="syne" style={{ fontWeight: 700, fontSize: 20 }}>{selectedMusician.title}</div>
                <div style={{ color: "var(--muted)", fontSize: 13, marginTop: 2 }}>Client: {selectedMusician.client}</div>
              </div>
              <button className="close-btn" onClick={() => setSelectedMusician(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div style={{ background: "var(--surface2)", borderRadius: 10, padding: 16, marginBottom: 20 }}>
                <div style={{ fontSize: 13, color: "var(--muted)", lineHeight: 1.7 }}>
                  <strong style={{ color: "var(--text)" }}>Project:</strong> {selectedMusician.needs}<br />
                  <strong style={{ color: "var(--text)" }}>Budget:</strong> <span style={{ color: "var(--accent)" }}>{selectedMusician.budget}</span><br />
                  <strong style={{ color: "var(--text)" }}>Deadline:</strong> {selectedMusician.deadline}
                  {selectedMusician.urgent && <span className="urgent-tag" style={{ marginLeft: 8 }}>Urgent</span>}
                </div>
              </div>
              <div className="form-row">
                <label className="form-label">Cover Letter</label>
                <textarea className="form-textarea" placeholder={`Tell ${selectedMusician.client} why you're the perfect fit...`} style={{ minHeight: 120 }} />
              </div>
              <div className="form-grid">
                <div className="form-row">
                  <label className="form-label">Your Rate</label>
                  <input className="form-input" placeholder="e.g. $180/hr" />
                </div>
                <div className="form-row">
                  <label className="form-label">Availability</label>
                  <select className="form-select"><option>Immediately</option><option>Within 2 days</option><option>Within 1 week</option></select>
                </div>
              </div>
              <button className="btn-primary" style={{ width: "100%" }} onClick={() => { showNotif("Proposal submitted!"); setSelectedMusician(null); }}>Submit Proposal →</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
